<template>
    <SwapMenu2 :swapid="myswapid" :title="mytitle" :period="period" :margin="widthclass">
    <template v-slot:menu>
        <li><a class="dropdown-item" @click=refresh()>Refresh</a></li>
        <li><a v-if="interval == 0" 
            class="dropdown-item" @click=start_interval()>Start Interval</a></li>
        <li><a v-if="interval > 0" 
            class="dropdown-item" @click=stop_interval()>Stop Interval</a></li>
    </template>
    </SwapMenu2>
    <div class="divstyle table-responsive">
        <table class="table table-striped table-bordered font-custom">
            <thead>
                <tr>
                    <th v-for="h in headers" :key="h"> {{ h }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="myrow in fifodata" :key="myrow.cols[0]">
                    <td v-for="c in myrow.cols" :key="c" class="colpad" 
                        :style="myrow.xstyle">
                    {{ c }}</td>
                </tr>
            </tbody>
        </table>
    </div>    
</template>

<style scoped>
.font-custom {
    font-size : 10pt ;
    text-align: left ;
}
.colpad {
    padding: 0.1rem !important ;
}
.divstyle {
    font-size : 10pt ;
    overflow-y: auto;
    margin-top: 0px ;
}
.aligncenter {
    text-align: center ;
}
</style>

<script>
import SwapMenu2 from './SwapMenu2.vue' 
import axios from 'axios' 
import convert from '../js/convert.js'

export default {
  name: 'BarChart',
  components: {
      SwapMenu2
  },
  props: {
    swapid : String,
    globid : String,
    screensize : String,
    mapobj : Object,        // widget type
    title  : String,
    period : Number
  },
  data() {
    return  {
      start : 0,
      interval : 0,
      curinterval : 0,
      headers : [ "1","2","3","4","5" ],
      lastseq : 0,
      fifotab : []
    }
  },
  computed : {
      widthclass() {
        if (this.screensize.length == 3)
            return this.screensize.substr(2) ;
        else return "1" ;
      },
      heightclass() {
        if (this.screensize.length == 3)
            return this.screensize.substr(0,1) ;
        else return "1" ;
     },
     myswapid() {
        if (this.mapobj.disptag) {
            let swap = this.$store.getters.getswap_byid(this.swapid) ;
            return (swap) ? swap.tag : this.swapid ;
        }
        return this.swapid ;
     },
     mytitle() {
        if (this.mapobj.disptag) {
            let swap = this.$store.getters.getswap_byid(this.mapobj.logaddr) ;
            if (this.mapobj.disptag == 1)
                return "FIFO @" + (swap) ? swap.tag : this.swapid ; 
            else
                return this.mapobj.disptag ;
        }
        return "FIFO @" + this.mapobj.logaddr  ;
     },
     fifodata() {
          return this.fifotab ;
     }
  },
  mounted() {
    this.start_interval();
  },
  unmounted() {
    this.stop_interval();
  },
  methods : {
    start_interval()
    {
        if (this.interval == 0) { 
            this.interval = setInterval(() => this.refresh(), this.period)
        }
        else alert ("interval has been started") ;
    },
    stop_interval()
    {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = 0 ;
        }
        else alert ("no interval has been started") ;
    },
    refresh() {

        let req = "" ;
        let logaddr = this.mapobj.logaddr ;
        try {
            req = this.$store.getters.controller_url +
                  "/prosw/fifo/get" +
                  "?swapid=" + this.swapid + "&logaddr=" 
                    + logaddr + "&lastseq=" + this.lastseq 
        }
        catch(err) {
           console.log(err) ;
           return ;
        }
        axios.get (req, {
            timeout: 5000,
            headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
           if (response.data.RC != "00") {
               let rowx = { "xstyle" : "background-color:red;color:white",
                         "cols"   : [ "RC", response.data.RC, "DESC",
                                      response.data.RDESC ]
               }
               this.fifotab.unshift(rowx) ;
               let maxrow = (this.heightclass == "1") ? 9 : 22 ;
               while (this.fifotab.length > maxrow ) {
                     this.fifotab.pop()
               }
               return console.log("ERROR RC:" + response.data.RC) ;
           }
           else {
             let resarr = response.data.RESULT ;
             let maxrow = (this.heightclass == "1") ? 9 : 22 ;
             var inset = convert(this.mapobj.display) ;
             if (inset[0] != 0) inset.unshift (0) ;     // col[0] is key
             let filters = this.mapobj.filter ;
             let n_rec = resarr.length ;
             this.start = 0 ;

             let updatefifo = () => {
                let end = Math.min(this.start + maxrow, n_rec) ;
                console.log ("start :" + this.start + " end:" + end) ;
                for (let i = this.start ; i < end ; i++) {
                  // console.log ( i + ' n_rec' + n_rec) ;
                  let col = resarr[i].split(",") ; 
                  let result = []
                  let header = []
                  this.lastseq = parseInt(col[0]) ;
                  if ("S-R,S-A,R-R,R-A".includes(col[2]) ) {
                    for (let k = 0 ; k < inset.length ; k++) {
                      let x = (inset[k] >= col.length) ? 0 : inset[k] ;
                      result[k] = col[x] ;
                    }
                  }
                  else if (col[2] == "HEADER") {
                    for (let k = 0 ; k < inset.length ; k++) {
                      let x = (inset[k] + 3 >= col.length) ? 3 : inset[k] + 3;
                      header[k] = col[x] ;
                    }
                    this.headers = header ;
                    continue ;
                  }
                  else continue ;

                  let action = null ;
                  let actarg = null ; 
                  for (let k = 0 ; k < filters.length ; k++) {
                    try {
                      let xcond = eval(filters[k].cond) ;
                      if (xcond) {
                          action = filters[k].action ;
                          actarg = filters[k].arg ;
                          break ;
                       }
                     }
                     catch (error) {
                        console.log ("cond error") ;
                     }
                  }
                  let xstyle=""
                  if (action) {
                    if (action == "style") 
                        xstyle=actarg ;  
                  }
                  let rowx = { "xstyle" : xstyle,
                         "cols"   : result 
                  }
                  this.fifotab.unshift(rowx) ;

                  while (this.fifotab.length > maxrow ) {
                     this.fifotab.pop()
                  }
                }

                this.lastseq++ ;       // 1 more than the last retrieve
                this.start += maxrow ;
                console.log ("last seq:" + this.lastseq) ;
                console.log ("end start " + this.start + " n_rec:" + n_rec) ;

                if (n_rec > this.start && this.curinterval) {
                       setTimeout(updatefifo, this.curinterval);
                }
             }

             if (n_rec > 0 && n_rec <= maxrow) 
               updatefifo() ;
             else if (n_rec > maxrow) {
               let interval =  parseInt (this.period /( n_rec / maxrow + 1));
               if (interval > 1000) interval = 1000 ;
               if (interval < 100) interval = 100 ;
               console.log ("interval: " + interval) ;
               this.curinterval = interval ;
               console.log ("set interval:" + this.curinterval) ;
               setTimeout(updatefifo, interval);
             }
          }
       }).catch ( (error) => { console.log(error) } )
    }
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>


